/* unplugin-vue-components disabled */import script from "./tabs.vue?vue&type=script&setup=true&lang=js"
export * from "./tabs.vue?vue&type=script&setup=true&lang=js"

import "./tabs.vue?vue&type=style&index=0&id=0f6d9924&lang=less&scoped=true"
import "./tabs.vue?vue&type=style&index=1&id=0f6d9924&lang=less"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0f6d9924"]])

export default __exports__